import React, { useEffect, useState } from "react";
import { Header } from "../Header";
import { Menu } from "../Menu";
import { Toolbar } from "../Toolbar";
import {
  AttributesDrawer,
  AttributesDrawerMobile,
} from "../../components/Attributes";
import { Visualizer } from "../Visualizer";
import { RouteComponentProps, useHistory, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {getAttributes, getHistory, getLoaded} from "../../reducers/project/selectors";
import { ProjectActions } from "../../reducers/project/actionsNames";
import { useFetch } from "../../hooks/useFetch";
import {Category, IAttributes, IProject} from "../../reducers/project";
import { cloneDeep } from "lodash/fp";
import { mockData } from "../../data";
import { Desktop, Mobile, useMobile } from "../../components/Responsive";
import PriceExpanderMobile from "../PriceExpander/PriceExpanderMobile";
import { Button } from "../../components/Button";
import content from "../../content";
import { Apps } from "@material-ui/icons";

function Creator({ match }: ICreator) {
  const loaded = useSelector(getLoaded);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const [response, request] = useFetch<{ attributes: IAttributes[] }>(
    "/attribute"
  );
  const [responseProject, requestProject] = useFetch<IProject>(
    "/project/",
    {} as any,
    { method: "GET", body: null }
  );

  const attributes = useSelector(getAttributes)

  const mobile = useMobile();

  useEffect(() => {
    request();
  }, []);

  useEffect(() => {
    if (response && attributes.length === 0) {
      dispatch({
        type: ProjectActions.SetAttributes,
        attr: cloneDeep(
          response.attributes.map((attr) => ({
            ...attr,
            dependency: Array.isArray(attr.dependency) ? {} : attr.dependency,
          }))
        ),
      });
    }
  }, [response, attributes]);

  useEffect(() => {
    if (match.params?.id && !loaded) {
      requestProject({}, match.params?.id).then((data) => {
        if (data) {
          dispatch({ type: ProjectActions.SetLoaded, loaded: true });


          const attr =  data.components.filter(Boolean).find(c => c.category === Category.Model)

          fetch(process.env.REACT_APP_API_URL + `/attribute?model=${attr?.slug.split('_')[0]}`, ).then(data => data.json()).then(modelData => {

            const attrClone = cloneDeep(
              modelData.attributes.map((attr) => ({
                ...attr,
                dependency: Array.isArray(attr.dependency) ? {} : attr.dependency,
              })))

            dispatch({
              type: ProjectActions.SetAttributes,
              attr: attrClone,
            });

            dispatch({ type: ProjectActions.LoadProject, project: data });

          })
        }
      });
    }
  }, [loaded]);

  return (
    <>
      <Desktop>
        <Menu />
      </Desktop>
      <div
        style={{
          width: "100%",
          height: mobile ? "100%" : "calc(100% - 41px)",
          display: "flex",
          flexDirection: mobile ? "column" : "row",
          overflow: "hidden",
        }}
      >
        <Toolbar />
        <Visualizer />
        <Desktop>
          <AttributesDrawer open={true} onClose={() => {}} />
        </Desktop>
        <Mobile>
          <PriceExpanderMobile />
          <div
            style={{
              backgroundColor: "#C41230",
              position: "absolute",
              marginTop: "10px",
                left: "50%",
                transform: "translateX(-50%)"
            }}
          >
            <Button
              onClick={() => setOpen(true)}
              variant={"text"}
              style={{ color: "white" }}
              Icon={<Apps />}
              label={content.getValue("button_select_components")}
            />
          </div>
          <AttributesDrawerMobile open={open} onClose={() => setOpen(false)} />
        </Mobile>
      </div>
    </>
  );
}

export interface ICreator extends RouteComponentProps<{ id?: string }> {}

export default Creator;
